import ConfirmBrowserRefresh from './confirm-browser-refresh'
import { PhoneNumberMask } from './input-masks.js'
import ScrollToTopOnClick from './scroll-top'
import StickyCta from './sticky-cta'

export const Hooks = {
  ConfirmBrowserRefresh,
  PhoneNumberMask,
  ScrollToTopOnClick,
  StickyCta,
}
